import { buildQueryString, logWithAmplitude, post, throwHttpError } from './api';

import { CreateImageRequest } from '../../types';

export async function uploadImage(
    amplitude_callsite: string,
    image: CreateImageRequest,
    orientation?: number
): Promise<string> {
    const queryString = buildQueryString({ orientation });
    // dont use custom host here because it might be a custom domain or environment
    const response = await fetch(`/i/upload${queryString}`, post(image));
    if (!response.ok) {
        await throwHttpError(
            `An error occurred while uploading an image (${image.name}).`,
            response
        );
    }

    const url = await response.text();

    logWithAmplitude(amplitude_callsite, 'Image Uploaded');

    return url;
}

export function isValidImageUrl(url: string): boolean {
    if (!url) return true; // Allow empty URLs

    try {
        const urlObj = new URL(url);

        // Check if protocol is http or https
        if (!['http:', 'https:'].includes(urlObj.protocol)) {
            return false;
        }

        // Check if URL path or query contains image extensions
        const imageExtensions = /\.(png|jpe?g|gif|svg|webp)(\?|$|#)/i;
        const fullUrl = urlObj.pathname + urlObj.search;

        return imageExtensions.test(fullUrl);
    } catch {
        return false;
    }
}